var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoalsSummary = exports.GoalRow = void 0;

var _react = _interopRequireDefault(require("react"));

var _FontelloIcon = _interopRequireDefault(require("../../../Basic/FontelloIcon"));

var _Basic = require("../../../../../elements/Basic");

var _i18n = _interopRequireDefault(require("../../../../../i18n"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Liveticker/Header/Components/GoalsSummary.js";

var GoalRow = function GoalRow(_ref) {
  var name = _ref.name,
      minute = _ref.minute,
      away = _ref.away,
      ownGoal = _ref.ownGoal;
  return _react.default.createElement(_Basic.Row, {
    reverseRow: away,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 5
    }
  }, _react.default.createElement(_Basic.Column, {
    flexing: true,
    alignRight: !away,
    alignLeft: away,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 9
    }
  }, _react.default.createElement(_Basic.Row, {
    center: true,
    reverseRow: away,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 13
    }
  }, _react.default.createElement(_Basic.Text, {
    size: "medium",
    alignRight: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 17
    }
  }, name, ownGoal ? " " + (0, _i18n.default)('own_goal') : null), _react.default.createElement(_FontelloIcon.default, {
    name: "GOAL",
    mx: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 17
    }
  }))), _react.default.createElement(_Basic.View, {
    center: true,
    isFlex: true,
    width: "30px",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 9
    }
  }, _react.default.createElement(_Basic.Text, {
    size: "medium",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 13
    }
  }, minute, "'")), _react.default.createElement(_Basic.Column, {
    flexing: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 9
    }
  }));
};

exports.GoalRow = GoalRow;
GoalRow.defaultProps = {
  away: false,
  ownGoal: false
};

var GoalsSummary = function GoalsSummary(_ref2) {
  var goals = _ref2.goals;
  return _react.default.createElement(_Basic.Column, {
    mb: 2,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 5
    }
  }, goals.map(function (item, index) {
    return _react.default.createElement(GoalRow, {
      key: "goalRow_" + item.minute + "_" + item.player.lastName,
      name: item.player.nickName || item.player.lastName,
      minute: item.minute,
      away: item.away,
      ownGoal: item.ownGoal,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33,
        columnNumber: 13
      }
    });
  }));
};

exports.GoalsSummary = GoalsSummary;